import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import Comments from "../Comments/Comment";
import { FixColumn } from "../../../../utils/dataTable";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import SingleDayGroupModal from "../../SingleDayGroupModal";
import emailIcon from "../../../../Assets/Images/Email.svg";
export const HighDemandDates = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        highDemandTable: commonService.GenerateGUID(),
    });
    const [otbModal, setOtbModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const widgetDetailRef = useRef();
    const singleDateTypeRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const [highDemandData, setHighDemandData] = useState(null);
    const [highDemandLoading, setHighDemandLoading] = useState(false);
    const eventListForHighDemandRef = useRef([]);
    const selectedEventDateRef = useRef();
    const eventListPropsRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [eventLoading, setEventLoading] = useState(false);
    const eventListRef = useRef();
    const allEventSourceIdFromDbRef = useRef();
    const [eventData, setEventData] = useState(null);

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };
    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const handleOtbClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setOtbModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const sevenDayPickupRef = useRef();

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.highDemandTable} .perbackground-otb`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.highDemandTable} .perbackground-adr`
    );
    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.highDemandTable} .perbackground-room`
    );
    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.highDemandTable} .perbackground-1room`
    );
    commonService.setBackColorPerByTDValue(
        "#FFC140",
        "Red",
        `#${tblids.highDemandTable} .perbackground-GroupOTB`
    );
    FixColumn(tblids.highDemandTable, [1]);
    const getEventFromDotNet = async () => {
        let eventListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: propertyDetailFromRTK?.propertyid,
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: "",
                },
            },
            false
        );

        let response = apiResponse(false, eventListResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let eventsList = [];

            dataFromApi?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: moment(item?.startdate).format("YYYY-MM-DD"),
                        endDate: moment(item?.enddate).format("YYYY-MM-DD"),
                        start: moment(item?.startdate).format("YYYY-MM-DD"),
                        end: moment(item?.enddate).format("YYYY-MM-DD"),
                        title: item?.eventname,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                        backgroundColor: "#ffebeb",
                        textColor: "black",
                        className: "poiter-event-none",
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventsList.push(singleEventObj);
                }
                catch (err) { }
            });
            eventListRef.current = [...eventListRef.current, ...eventsList];
        }

        if (!response?.isValidate) {
        }
    };
    const getEventFromDotNetForHighDemand = async () => {
        let eventListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: propertyDetailFromRTK?.propertyid,
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: "",
                },
            },
            false
        );

        let response = apiResponse(false, eventListResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let eventsList = [];

            dataFromApi?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: moment(item?.startdate).format("YYYY-MM-DD"),
                        endDate: moment(item?.enddate).format("YYYY-MM-DD"),
                        start: moment(item?.startdate).format("YYYY-MM-DD"),
                        end: moment(item?.enddate).format("YYYY-MM-DD"),
                        title: item?.eventname,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                        backgroundColor: "#ffebeb",
                        textColor: "black",
                        className: "poiter-event-none",
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventsList.push(singleEventObj);
                }
                catch (err) { }
            });
            eventListForHighDemandRef.current = [
                ...eventListForHighDemandRef.current,
                ...eventsList,
            ];
        }

        if (!response?.isValidate) {
        }
    };
    const getEventData = async () => {
        setEventLoading(true);
        eventListRef.current = [];
        await getEventSourceIdFromDb();
        let eventDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.TOP_10_EVENT_STRETERGY,
                body: {
                    AsOfDate: asOfDateFromRTK ? asOfDateFromRTK : "",
                    propertyid: propertyDetailFromRTK?.propertyid,
                    propertyCode: propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, eventDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let eventNotExistsInDb = [];
            dataFromApi?.forEach((item) => {
                item?.Event_details?.forEach((eventItem) => {
                    let eventExistsInDb = allEventSourceIdFromDbRef.current?.filter(
                        (x) => x === eventItem?.event_id
                    );
                    if (eventExistsInDb?.length <= 0) {
                        let singleEventObj = {
                            id: eventItem?.event_id,
                            name: eventItem?.title,
                            detail: eventItem?.description,
                            startDate: moment(eventItem?.start_date).format("YYYY-MM-DD"),
                            endDate: moment(eventItem?.end_date).format("YYYY-MM-DD"),
                            start: moment(eventItem?.start_date).format("YYYY-MM-DD"),
                            end: moment(eventItem?.end_date).format("YYYY-MM-DD"),
                            title: eventItem?.title,
                            labels: eventItem?.labels,
                            rank: eventItem?.rank ? eventItem?.rank : 0,
                            local_rank: eventItem?.local_rank ? eventItem?.local_rank : 0,
                            phq_attendance: eventItem?.phq_attendance
                                ? eventItem?.phq_attendance
                                : 0,
                            geo_lat: eventItem?.geo_lat ? eventItem?.geo_lat : "",
                            geo_long: eventItem?.geo_long ? eventItem?.geo_long : "",
                            backgroundColor: "#e1e8ff",
                            textColor: "black",
                            className: "poiter-event-none",
                            eventJson: eventItem,
                        };
                        eventNotExistsInDb.push(singleEventObj);
                    }
                });
            });
            eventListRef.current = eventNotExistsInDb;
            await getEventFromDotNet();
            setEventData(response?.data?.data);
            setEventLoading(false);
        }

        if (!response?.isValidate) {
            eventListRef.current = [];
            setEventData(null);
            setEventLoading(false);
        }
    };

    const getHighDemandDates = async () => {
        setHighDemandLoading(true);
        eventListForHighDemandRef.current = [];
        let highDemandDatesResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.HIGH_DEMAND_DATES,
                body: {
                    propertyCode: propertyCode,
                    asofdate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
                },
            },
            false
        );

        let response = apiResponse(false, highDemandDatesResponse);

        if (response?.isValidate) {
            let eventNotExistsInDb = [];
            let dataFromApi = response?.data?.data;
            dataFromApi?.forEach((item) => {
                item?.Event_details?.forEach((eventItem) => {
                    let eventExistsInDb = allEventSourceIdFromDbRef.current?.filter(
                        (x) => x === eventItem?.event_id
                    );
                    if (eventExistsInDb?.length <= 0) {
                        let singleEventObj = {
                            id: eventItem?.event_id,
                            name: eventItem?.title,
                            detail: eventItem?.description,
                            startDate: moment(eventItem?.start_date).format("YYYY-MM-DD"),
                            endDate: moment(eventItem?.end_date).format("YYYY-MM-DD"),
                            start: moment(eventItem?.start_date).format("YYYY-MM-DD"),
                            end: moment(eventItem?.end_date).format("YYYY-MM-DD"),
                            title: eventItem?.title,
                            labels: eventItem?.labels,
                            rank: eventItem?.rank ? eventItem?.rank : 0,
                            local_rank: eventItem?.local_rank ? eventItem?.local_rank : 0,
                            phq_attendance: eventItem?.phq_attendance
                                ? eventItem?.phq_attendance
                                : 0,
                            geo_lat: eventItem?.geo_lat ? eventItem?.geo_lat : "",
                            geo_long: eventItem?.geo_long ? eventItem?.geo_long : "",
                            backgroundColor: "#e1e8ff",
                            textColor: "black",
                            className: "poiter-event-none",
                            eventJson: eventItem,
                        };
                        eventNotExistsInDb.push(singleEventObj);
                    }
                });
            });
            eventListForHighDemandRef.current = eventNotExistsInDb;
            await getEventFromDotNetForHighDemand();
            setHighDemandData(response?.data?.data);
            setHighDemandLoading(false);
        }

        if (!response?.isValidate) {
            eventListForHighDemandRef.current = [];
            setHighDemandData(null);
            setHighDemandLoading(false);
        }
    };

    const closeOtbClick = () => {
        selectedTdIndexRef.current = -1;
        setOtbModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };


    const funcForEventAndHighDemandData = async () => {
        await getEventData();
        getHighDemandDates();
        let date = new Date(asOfDateFromRTK);
        let sevenDayDate = new Date().setDate(date.getDate() - 7);
        sevenDayPickupRef.current = sevenDayDate;
    };

    const getEventSourceIdFromDb = async () => {
        setHighDemandLoading(true);
        let eventSourceIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.EVENTS.GET_ALL_EVENT_SOURCE_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let response = apiResponse(false, eventSourceIdResponse);

        if (response?.isValidate) {
            let splitArray = response?.data?.data?.split(",");
            allEventSourceIdFromDbRef.current = splitArray;
        }

        if (!response?.isValidate) {
            allEventSourceIdFromDbRef.current = null;
            setHighDemandLoading(false);
        }
    };
    useEffect(() => {
        if (api === 0) {

        } else {
            if (asOfDateFromRTK) {
                funcForEventAndHighDemandData();
            }
        }
    }, [para?.propertyCode]);

    return (
        <div className="widget-container" style={{position: "relative"}}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button
                        className="heading-menu-btns"
                        type="button"
                        title="Send Mail"
                    >
                        <img id={commonService.generateGlobalClickTrackerID("HighDemandDates", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.highDemandTable,
                                    "HighDemandDates",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("HighDemandDates", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.HighDemandDates,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("HighDemandDates", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.highDemandTable}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.highDemandTable,
                                    `${para?.propertyCode}-HighDemandDates-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <Row>
                <Col xl={12}>
                    <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                            <Table id={tblids?.highDemandTable} responsive>
                                <thead>
                                    <tr>
                                        <th className="text-center" colSpan={50}>
                                            High Demand Dates
                                        </th>
                                    </tr>
                                    <tr>
                                        <th colSpan={5} className="border_right"></th>
                                        <th className="border_right text-center" colSpan={5}>
                                            TRANSIENT CURRENT YEAR
                                        </th>
                                        <th className="border_right text-center" colSpan={2}>
                                            Revenue
                                        </th>
                                        <th className="border_right text-center">Group</th>
                                        <th className="border_right text-center" colSpan={2}>
                                            Bar Based Stats
                                        </th>
                                        <th className="border_right text-center" colSpan={3}>
                                            1 Day Pickup
                                        </th>
                                        <th className="border_right text-center" colSpan={3}>
                                            7 Day Pickup
                                        </th>
                                        <th className="text-center border_right" colSpan={3}>
                                            Pricing & Forecast
                                        </th>
                                        {highDemandData?.[0]?.Rateshop && (
                                            <th
                                                colSpan={highDemandData?.[0]?.Rateshop?.length + 1}
                                                className="text-center"
                                            >
                                                RateShop
                                            </th>
                                        )}
                                    </tr>
                                    <tr>
                                        <th className="border_right">Stay Date</th>
                                        <th className="border_right">DOW</th>
                                        <th className="border_right text-center">Occ%</th>
                                        <th className="text-center border_right">Occ% Change</th>
                                        <th className="text-center border_right width150">
                                            Events
                                        </th>
                                        <th className="width100">OOO\Rooms Available</th>
                                        <th className="width75 text-center">Left To sell</th>
                                        <th className="width75 text-center">On The Books</th>
                                        <th>Total OCC%</th>
                                        <th className="text-end border_right">ADR</th>
                                        <th className="text-end">Rev</th>
                                        <th className="text-end border_right">RevPAR</th>
                                        <th className="border_right">OTB\Block</th>

                                        <th className="width50 text-center">OTB</th>
                                        <th className="width100 text-center border_right">
                                            8 Week Rolling Avg
                                        </th>

                                        <th className="text-center">Rooms</th>
                                        <th className="text-end">ADR Change</th>
                                        <th className="text-end border_right">Rev</th>
                                        <th className="text-center">Rooms</th>
                                        <th className="text-end">ADR Change</th>
                                        <th className="text-end border_right">Rev</th>


                                        <th className="text-center width110">System Forecast</th>
                                        <th>R28 Avg</th>
                                        <th className="text-end border_right">Optimal Bar</th>
                                        {highDemandData &&
                                            highDemandData?.[0]?.Rateshop?.map((x) => {
                                                if (x.IsSelf === true) {
                                                    return (
                                                        <th
                                                            className="text-end border-right"
                                                            title={x?.competiterpropertyname}
                                                        >
                                                            {x?.competiterpropertyname?.length > 10
                                                                ? `${x?.competiterpropertyname?.slice(
                                                                    0,
                                                                    10
                                                                )}...`
                                                                : x?.competiterpropertyname}
                                                        </th>
                                                    );
                                                }
                                            })}
                                        {highDemandData?.[0]?.Rateshop && (
                                            <th className="text-end">Avg Competitor</th>
                                        )}
                                        {highDemandData &&
                                            highDemandData?.[0]?.Rateshop?.map((x) => {
                                                if (x.IsSelf === false) {
                                                    return (
                                                        <th
                                                            className="text-end"
                                                            title={x?.competiterpropertyname}
                                                        >
                                                            {x?.competiterpropertyname?.length > 10
                                                                ? `${x?.competiterpropertyname?.slice(
                                                                    0,
                                                                    10
                                                                )}...`
                                                                : x?.competiterpropertyname}
                                                        </th>
                                                    );
                                                }
                                            })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {highDemandLoading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : highDemandData?.length > 0 ? (
                                        highDemandData?.map((item, index) => {
                                            let checkEvent =
                                                eventListForHighDemandRef.current?.filter((x) => {
                                                    let checkingDate = moment(item?.StayDate);
                                                    let startingDate = moment(x?.startDate);
                                                    let endingDate = moment(x?.endDate);
                                                    if (
                                                        checkingDate.isSameOrAfter(startingDate) &&
                                                        checkingDate.isSameOrBefore(endingDate)
                                                    ) {
                                                        return x;
                                                    }
                                                });

                                            let isSelfData = item?.Rateshop?.filter((x) => {
                                                if (x.IsSelf === true) {
                                                    return x;
                                                }
                                            });
                                            let rateShoptotal = 0;
                                            item?.Rateshop?.map((x) => {
                                                if (x.IsSelf === false) {
                                                    rateShoptotal = rateShoptotal + parseFloat(x?.Rate);
                                                }
                                            });
                                            let findCompetitorData = item?.Rateshop?.filter(
                                                (x) => x.IsSelf === false
                                            );

                                            let findDataForAvgCount = item?.Rateshop?.filter(
                                                (x) => x.IsSelf === false && parseFloat(x.Rate) > 0
                                            );

                                            let avgCompetitor =
                                                rateShoptotal > 0 && findCompetitorData?.length > 0
                                                    ? Math.round(
                                                        rateShoptotal / findDataForAvgCount?.length
                                                    )
                                                    : 0;

                                            let foreCastSpiderTextColor = "";
                                            let forecastSpiderBorder = "";
                                            if (item?.Forecast_RMS < item?.R28AVG) {
                                                foreCastSpiderTextColor = "redText";
                                                let R28AvgPercentage = (item?.R28AVG * 10) / 100;
                                                let finalValue = item?.R28AVG - R28AvgPercentage;
                                                if (item?.Forecast_RMS < finalValue) {
                                                    forecastSpiderBorder = "redBorderTd";
                                                }
                                            } else {
                                                let R28AvgPercentage = (item?.R28AVG * 10) / 100;
                                                let finalValue = item?.R28AVG + R28AvgPercentage;
                                                if (item?.Forecast_RMS > finalValue) {
                                                    forecastSpiderBorder = "blackBorderTd";
                                                }
                                            }

                                            return (
                                                <tr className="shadowOnHover">
                                                    <td className="border_right">
                                                        {item?.StayDate
                                                            ? commonService.getDateInFormat(item?.StayDate)
                                                            : ""}
                                                    </td>
                                                    <td className="border_right">{item?.DayOfWeek}</td>
                                                    <td className="border_right text-center">
                                                        {item?.Occperc ? item?.Occperc : 0}%
                                                    </td>
                                                    <td className="text-center border_right">
                                                        {item?.OccuPercChange ? item?.OccuPercChange : 0}%
                                                    </td>
                                                    <td id={commonService.generateGlobalClickTrackerID("HighDemandDates", "high-demand-dates-events", item)}
                                                        className="text-center border_right text-primary cursorPointer"
                                                        title={item?.title}
                                                        onClick={() => {
                                                            selectedEventDateRef.current = item?.StayDate;
                                                            eventListPropsRef.current = checkEvent;
                                                            setShowTicketModal(true);
                                                        }}
                                                    >
                                                        {item?.title?.length > 20
                                                            ? `${item?.title?.slice(0, 20)}...`
                                                            : item?.title}{" "}
                                                        {item?.Event_Count && item?.title
                                                            ? `(${item?.Event_Count})`
                                                            : ""}
                                                    </td>
                                                    <td className="width100">
                                                        {item?.OnTheBook?.[0]?.OOO
                                                            ? item?.OnTheBook?.[0]?.OOO
                                                            : 0}
                                                        {"/"}
                                                        {item?.OnTheBook?.[0]?.RoomAvailable
                                                            ? item?.OnTheBook?.[0]?.RoomAvailable
                                                            : 0}
                                                    </td>
                                                    <td className="text-center">
                                                        {item?.OnTheBook?.[0]?.LeftToSell
                                                            ? commonService.formateRoom(
                                                                item?.OnTheBook?.[0]?.LeftToSell
                                                            )
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td
                                                        className="text-primary text-center perbackground perbackground-otb"
                                                        value={
                                                            item?.OnTheBook?.[0]?.OnTheBook
                                                                ? item?.OnTheBook?.[0]?.OnTheBook
                                                                : 0
                                                        }
                                                    >
                                                        <span id={commonService.generateGlobalClickTrackerID("HighDemandDates", "high-demand-dates-transient-current", item)}
                                                            className={`${selectedTdIndexRef.current === index &&
                                                                singleDateTypeRef.current === "highDemand"
                                                                ? "singleDateSummarySpan"
                                                                : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateTypeRef.current = "highDemand";
                                                                singleDateSelectedDateRef.current =
                                                                    item?.StayDate;
                                                                handleFilterBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {item?.OnTheBook?.[0]?.OnTheBook
                                                                ? item?.OnTheBook?.[0]?.OnTheBook
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {item?.OnTheBook?.[0]?.TotalOCCPercentage
                                                            ? item?.OnTheBook?.[0]?.TotalOCCPercentage
                                                            : 0}
                                                        %
                                                    </td>
                                                    <td
                                                        className="text-end perbackground perbackground-adr border_right"
                                                        value={item?.OnTheBook?.[0]?.ADR}
                                                    >
                                                        {item?.OnTheBook?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                item?.OnTheBook?.[0]?.ADR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {item?.OnTheBook?.[0]?.REV
                                                            ? commonService.formateAmount(
                                                                item?.OnTheBook?.[0]?.REV
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end border_right">
                                                        {item?.OnTheBook?.[0]?.RevPAR
                                                            ? commonService.formateAmount(
                                                                item?.OnTheBook?.[0]?.RevPAR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td
                                                        className="perbackground perbackground-GroupOTB border_right text-center text-primary"
                                                        value={item?.OnTheBook?.[0]?.OTB}
                                                    >
                                                        <span id={commonService.generateGlobalClickTrackerID("HighDemandDates", "high-demand-dates-group-otb-block", item)}
                                                            className={`${selectedTdIndexRef.current === index &&
                                                                singleDateTypeRef.current === "highDemand"
                                                                ? "singleDateSummarySpan"
                                                                : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateTypeRef.current = "highDemand";
                                                                singleDateSelectedDateRef.current =
                                                                    item?.StayDate;
                                                                handleOtbClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {item?.OnTheBook?.[0]?.OTB
                                                                ? commonService.formateRoom(
                                                                    item?.OnTheBook?.[0]?.OTB
                                                                )
                                                                : 0}
                                                            \
                                                            {item?.OnTheBook?.[0]?.Block
                                                                ? commonService.formateRoom(
                                                                    item?.OnTheBook?.[0]?.Block
                                                                )
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        {item?.Bar_Based_OTB
                                                            ? commonService.formateRoom(item?.Bar_Based_OTB)
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td className="text-center border_right">
                                                        {item?.Bar_Based_8week_AVG
                                                            ? commonService.formateRoom(
                                                                item?.Bar_Based_8week_AVG
                                                            )
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td
                                                        className="perbackground perbackground-1room text-center"
                                                        value={item?.["1 Day Pickup"]?.[0]?.RMS}
                                                    >
                                                        {item?.["1 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateRoom(
                                                                item?.["1 Day Pickup"]?.[0]?.RMS
                                                            )
                                                            : 0}
                                                    </td>
                                                    <td className="text-end">
                                                        {item?.["1 Day Pickup"]?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                item?.["1 Day Pickup"]?.[0]?.ADR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td className="text-end border_right">
                                                        {item?.["1 Day Pickup"]?.[0]?.ADR && item?.["1 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateAmount(
                                                                parseFloat(item?.["1 Day Pickup"]?.[0]?.ADR) * parseFloat(item?.["1 Day Pickup"]?.[0]?.RMS)
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td
                                                        className="perbackground perbackground-room text-center"
                                                        value={item?.["7 Day Pickup"]?.[0]?.RMS}
                                                    >
                                                        {item?.["7 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateRoom(
                                                                item?.["7 Day Pickup"]?.[0]?.RMS
                                                            )
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {item?.["7 Day Pickup"]?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                item?.["7 Day Pickup"]?.[0]?.ADR
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end border_right">
                                                        {item?.["7 Day Pickup"]?.[0]?.ADR && item?.["7 Day Pickup"]?.[0]?.RMS
                                                            ? commonService.formateAmount(
                                                                parseFloat(item?.["7 Day Pickup"]?.[0]?.ADR) * parseFloat(item?.["7 Day Pickup"]?.[0]?.RMS)
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>

                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <p
                                                                className={`${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                style={{ padding: "2px" }}
                                                            >
                                                                {item?.Forecast_RMS
                                                                    ? commonService.formateRoom(
                                                                        item?.Forecast_RMS
                                                                    )
                                                                    : commonService.formateRoom(0)}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item?.R28AVG
                                                            ? commonService.formateRoom(item?.R28AVG)
                                                            : commonService.formateRoom(0)}
                                                    </td>
                                                    <td className="text-end border_right">
                                                        {item?.Optimal_BAR
                                                            ? `${commonService.formateAmount(
                                                                item?.Optimal_BAR
                                                            )}`
                                                            : `${commonService.formateAmount(0)}`}
                                                    </td>
                                                    {item?.Rateshop && (
                                                        <td
                                                            className={`text-end ${isSelfData?.[0]?.Rate < avgCompetitor
                                                                ? "greenText"
                                                                : "redText"
                                                                }`}
                                                        >
                                                            {isSelfData?.length > 0
                                                                ? `${commonService.formateAmount(
                                                                    Math.round(isSelfData[0]?.Rate)
                                                                )}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                    )}

                                                    {item?.Rateshop && (
                                                        <td className="text-end">
                                                            {avgCompetitor
                                                                ? `${commonService.formateAmount(
                                                                    avgCompetitor
                                                                )}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                    )}
                                                    {item?.Rateshop?.map((x) => {
                                                        if (x.IsSelf === false) {
                                                            return (
                                                                <td className="text-end">
                                                                    {x?.Rate
                                                                        ? `${commonService.formateAmount(
                                                                            Math.round(x?.Rate)
                                                                        )}`
                                                                        : `${commonService.formateAmount(0)}`}
                                                                </td>
                                                            );
                                                        }
                                                    })}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="text-center">
                                            <td colSpan={50}>No Data Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Col>
            </Row>
            {api !== 0 && <Comments widgetDetails={para} editorId={"HighDemandDates"} />}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={asOfDateFromRTK}
                            selectedDate={singleDateSelectedDateRef.current}
                            pickupDate={sevenDayPickupRef.current}
                            propertyDetail={{
                                propertyCode: propertyDetailFromRTK?.propertycode,
                            }}
                        />
                    </div>
                </Popover>
            </Overlay>

            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventData}
                />
            )}

            <Overlay
                show={otbModal.IsDisplay}
                target={otbModal.Target}
                placement={otbModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayGroupModal
                            closeModal={closeOtbClick}
                            asOfDate={asOfDateFromRTK}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyDetailFromRTK?.propertycode}
                        />
                    </div>
                </Popover>
            </Overlay>
        </div>
    );
};


export default HighDemandDates;
